export default __webpack_public_path__ + "images/0x39551b1c26ce03714e4661833b0fa730174bd7e9.png";